import { ApolloError } from '@apollo/client';

import { useCardById } from 'apps/shared/scripts/graphql';

import { PlanType } from '../../__generated__/graphql.generated';

interface Options {
  id: string;
  onError?: (error: ApolloError) => void;
}

const useIsCardPro = ({ id, onError }: Options) => {
  const { card, isLoading } = useCardById({ variables: { id }, onError });
  const isPro = card?.plan === PlanType.Pro;
  return { isPro, isLoading };
};

export default useIsCardPro;
